import { cloneDeep, isEqual } from "lodash-es"
import { useMemo, useState } from "react"
export function useDraft<T>(
  initialValue: T,
  options?: { compare?: (a: T, b: T) => boolean },
) {
  const [data, setData] = useState<T>(initialValue)
  const [copiedData, setCopiedData] = useState(cloneDeep(data))
  const isChanged = useMemo(() => {
    if (options?.compare) {
      return options.compare(copiedData, data)
    }
    return !isEqual(copiedData, data)
  }, [copiedData, data, options?.compare])

  return { isChanged, copiedData, setCopiedData, setData, data }
}
